import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import courseActions from '@redux/course/actions';
import { CreateOrUpdateCourseReviewRequestAction } from '@redux/course/type/courseDetailType';
import { RootState } from '@redux/reducer';

const { createOrUpdateCourseReviewAction } = courseActions;

export type CreateOrUpdateCourseReviewPayload = Omit<CreateOrUpdateCourseReviewRequestAction, 'courseIdOrIdName'>;

type UseCourseReviewCreateOrUpdateProps = {
  idName?: string;
};

export const useCourseReviewCreateOrUpdate = ({ idName }: UseCourseReviewCreateOrUpdateProps) => {
  const dispatch = useDispatch();

  const { createOrUpdateCourseReviewState } = useSelector((state: RootState) => ({
    createOrUpdateCourseReviewState: state.Course.get('createOrUpdateCourseReviewState'),
  }));

  const handleCreateOrUpdateCourseReview = useCallback(
    (payload: CreateOrUpdateCourseReviewPayload) => {
      if (!idName) {
        return;
      }
      dispatch(
        createOrUpdateCourseReviewAction.request({
          courseIdOrIdName: idName,
          rating: payload.rating,
          comment: payload.comment?.trim(),
        }),
      );
    },
    [dispatch, idName],
  );

  const {
    data: createOrUpdateCourseReviewStateData,
    error: createOrUpdateCourseReviewDataError,
    isLoading: isCreateOrUpdateCourseReviewDataLoading,
    isError: isCreateOrUpdateCourseReviewDataError,
    isSuccess: isCreateOrUpdateCourseReviewDataSuccess,
  } = createOrUpdateCourseReviewState;

  return {
    handleCreateOrUpdateCourseReview,
    createOrUpdateCourseReviewStateData,
    createOrUpdateCourseReviewDataError,
    isCreateOrUpdateCourseReviewDataLoading,
    isCreateOrUpdateCourseReviewDataError,
    isCreateOrUpdateCourseReviewDataSuccess,
  };
};
